<template>
  <div fluid class="pa-0 ma-0">

    <div class="background">

        <div class="product-summary">
            <v-container>
                <div class="text-h2 text-center mb-10">
                    Privacy
                </div>

                <div class="my-10">
                    meetabout.it ("us", "we", or "our") hereby referred to as the "Service". This page informs you 
                    on how we collect, use and disclose your peronsal data when you use the Service. 
                    We use your data to provide and improve the Service. By using the Service, you acknowledge 
                    that your personal data will be processed as described in this Policy. 
                    <br><br>

                    <div class="text-h2">Definitions</div>
                    <div class="text-h6 mt-5">Personal Data</div>

                    Data that can be used to personally identify a living individual.  This data is obtained from use of the 
                    Service either through the application or 3rd party integrations.

                    <div class="text-h6 mt-5">Usage Data</div>

                    Data that is generated from use of the system either automatically or programatically.

                    <div class="text-h6 mt-5">Cookies</div>

                    Data stored in the users device on behalf of the Service

                    ‍<div class="text-h6 mt-5">Data Controller</div>

                    Data Controller means a person who (either alone or jointly orin common with other persons) determines 
                    the purposes for which and the manner in which any personal data are, or are to be, processed. For the 
                    purpose of this Privacy Policy, we are a Data Controller of your data.

                    <div class="text-h6 mt-5">Data Processor or Service Provider</div>

                    Data Processor (or Service Provider) means any person (other than an employee of the Data Controller)
                     who processes the data on behalf of the Data Controller.<br><br>

                    We may use the services of various Service Providers in order to process your data more effectively.

                    <div class="text-h6 mt-5">Data Subject</div>

                    Data Subject is any living individual who is the subject of Personal Data.

                    <div class="text-h6 mt-5">User</div>

                    The User is the individual using our Service. The User corresponds to the Data Subject, who is the subject of Personal Data.

                    <div class="text-h6 mt-5">Information Collection and User</div>

                    We collect several different types of information for various purposesto provide and improve our Service to you.

                    <div class="text-h6 mt-5">Types of Data Collected</div>
                    <div class="text-h6 mt-5">Personal Data</div>

                    While visitor our website or using our Service, we may ask you to provide us with certain Personal Data. 
                    The Personal Data we may collect includes, but is not limited to:<br>

                    <br>·       Email address

                    <br>·       First name and last name

                    <br>·       Profile picture

                    <br>·       Cookies and Usage Data<br><br>

                    We may use your Personal Data as further described in this Privacy Policy, such as to contact you with newsletters, 
                    marketing or promotional materials and other information that may be of interest to you. You may opt out of 
                    receiving any, or all, of these communications from us by following the unsubscribe link or instructions 
                    provided in any email we send.

                    <div class="text-h6 mt-5">Data Usage</div>

                    We also automatically collect information how the Service is accessed and used. This Usage Data may include 
                    information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, 
                    the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique 
                    device identifiers and other diagnostic data.

                    <div class="text-h6 mt-5">Tracking Data Cookies</div>

                    We use cookies and similar tracking technologies to track the activity on our Service and hold certain information.
                    <br><br>
                    Cookies are files with small amount of data which may include an anonymous unique identifier. Cookies are sent to your 
                    browser from a website and stored on your device. Tracking technologies also used are beacons, tags, and scripts to collect 
                    and track information and to improve and analyze our Service. 

                    <br><br>We and our Service Providers also use beacons and tags in HTML emails to our customers to help us track email 
                    response rates, identify when our emails are viewed, and track whether our emails are forwarded.
                    <br><br>
                    You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.

                    <div class="text-h6 mt-5">Examples of Cookies</div>
                    Examples of Cookies we use:

                    We use Session Cookies to operate our Service.<br>
                    We use Preference Cookies to remember your preferences and various settings.<br>
                    We use Security Cookies for security purposes.<br>
                    ‍Use of Data<br><br>

                    The Service uses the collected data for various purposes:<br><br>

                    To provide and maintain our Service<br>
                    To gather and maintain usage information of the Service to improve our applications<br>
                    To gather analysis or valuable information so that we can improve our website and Service<br>
                    To monitor the usage of our Service<br>

                    <div class="text-h6 mt-5">How Long We Keep Your Data</div>
                    The Service will only keep your Personal Data for as long as needed to meet the purposes of the Service or for 
                    internal data analysis of the Service.  We will 
                    also keep your data as long as necessary to comply with our legal obligations.
                    <br><br>

                    <div class="text-h6 mt-5">Transfer Of Data</div>
                    Your information, including Personal Data, may be transferred to — and maintained on — devices located outside of
                    your state, province, country or other governmental jurisdiction where the data protection laws may differ than
                    those from your jurisdiction.<br><br>

                    All data is processed in the United States and by using the Service you agree that your data will be transferred there 
                    in order to use the Service.<br><br>

                    By signing into the Service you agree to this policy.<br><br>

                    The Service will take steps reasonably necessary to ensure that your data is treated securely and in accordance 
                    with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country 
                    unless there are adequate controls in place including the security of your data and other personal information, 
                    including entering into data transfer agreements, or for Personal Data being transferred from the 
                    European EconomicArea (EEA), using the EU Commission approved standard contractual clauses, orby relying on
                     certification schemes such as the E.U. – U.S. Privacy Shield andSwiss – U.S. Privacy Shield for individuals 
                     located in Switzerland. You may have a right to details of the mechanisms under which your Personal
                      Data is transferred outside the EEA..<br><br>

                    <div class="text-h6 mt-5">Disclosure Of Data</div>
                    <div class="text-h6 mt-5">Business Transaction</div>

                    If The Service is involved in an actual or contemplated merger, acquisition or asset sale, financing, or a 
                    restructuring, your Personal Data may be transferred to another company. We will provide notice before your 
                    Personal Data is transferred and becomes subject to a different Privacy Policy. As part of the business 
                    transfer process, we may share certain of your PersonalData with lenders, auditors, and advisors,
                     including attorneys and consultants.

                    <div class="text-h6 mt-5">Disclosure for Law Enforcement</div>

                    Under certain circumstances, the Service may be required to disclose your Personal Data if required to do 
                    so by law or in response to valid requests by public authorities (e.g. a court or a government agency).

                    <div class="text-h6 mt-5">Affiliates</div>

                    We may disclose the information we collect from and about you to our affiliates or subsidiaries; however, 
                    if we do so, their use and disclosure of your Personal Data will be subject to this Policy.

                    ‍<div class="text-h6 mt-5">Legal Requirements</div>

                    The Service may disclose your Personal Data in the good faith belief that such action is necessary to:

                    <br><br>To comply with a legal obligation
                    <br><br>To protect and defend the rights or property of the Service
                    <br><br>To prevent or investigate possible wrongdoing in connection with the Service
                    <br><br>To protect the personal safety of users of the Service or the public
                    <br><br>To protect against legal liability
                    <br><br>Aggregate and De-Identified Information

                    <br><br>We share aggregate, anonymized, or de-identified information about website visitors and 
                    Services users with others for marketing, advertising, research, or similar purposes.

                    <div class="text-h6 mt-5">Security Of Data</div>
                    The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.

                    <div class="text-h6 mt-5">"Do Not Track" Signals</div>
                    We do not support Do Not Track ("DNT"). Do Not Track is a preference you can set in your web browser to inform websites that you do not want to be tracked.

                    You can enable or disable Do Not Track by visiting the Preferences or Settings page of your web browser.

                    <div class="text-h6 mt-5">Your Rights</div>
                    The Service aims to take reasonable steps to allow you to correct, amend, delete, or limit the use of your Personal Data as 
                    required by applicable law.

                    <br><br>Whenever made possible, you can update your Personal Data directly within your account settings section. If you are unable 
                    to change your Personal Data, please contact us to make the required changes.

                    <br><br>If you wish to be informed what Personal Data we hold about you and if you want it to be removed from our systems, please contact us.

                    <br><br>In certain circumstances, under applicable law, you may have the right:

                    <br><br>To access and receive a copy of the Personal Data we hold about you
                    <br><br>To rectify any PersonalData held about you that is inaccurate
                    <br><br>To request the deletion of Personal Data held about you
                    <br><br>To object to any processing of your Personal Data which has our legitimate interests as its legal basis, if you believe your fundamental rights and freedoms outweigh our legitimate interests. If you raise an objection, we have an opportunity to demonstrate that we have compelling legitimate interests which override your rights and freedoms.
                    <br><br>To restrict the use of your Personal Data when (i) you contest the accuracy of the data; (ii) the use is unlawful but you do not want us to erase the data; (iii) we no longer need the Personal Data for the relevant purposes, but we require it for the establishment, exercise, or defense of legal claims; or (iv) you have objected to our Personal Data use where such use is justified on our legitimate interests and we must verify as to whether we have a compelling interest to continue to use your data. We can continue to use your Personal Data following a request for restriction, where: we have your consent; or to establish, exercise or defend legal claims; or to protect the rights of another natural or legal person.
                    <br><br>You have the right to data portability for the information you provide to the Service. You can request to obtain a copy of your Personal Data in a commonly used electronic format so that you can manage and move it. Please note that we may ask you to verify your identity before responding to such requests.

                    <br><br>Data Subjects in the EEA have a right to lodge a complaint with their local supervisory authority if they have concerns about how we are processing their Personal Data. We ask that you please attempt to resolve any issues with us first, although you have a right to contact your supervisory authority at any time.

                    <br><br>Service Providers
                    We may employ third party companies and individuals to perform functions on our behalf, including to 
                    facilitate our Service ("Service Providers"), to provide the Service on our behalf, to perform Service-related 
                    services or to assist us in analyzing how our Service is used.

                    <br><br>These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.

                    <div class="text-h6 mt-5">Links To Other Sites</div>
                    Our Service may contain links to other sites that are not operated by us. If you click on a third party link,
                     you will be directed to that third party's site. We recommend you review the Privacy Policy of every site you visit.

                    <br><br>We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.

                    <div class="text-h6 mt-5">Children's Privacy</div>
                    Our Service does not address anyone under the age of 13 ("Children").

                    We do not knowingly collect personally identifiable information from anyone under the age of 13. 
                    If you are a parent or guardian and you are aware that your Children has provided us with Personal Data, 
                    please contact us. If we become aware that we have collected Personal Data from children without 
                    verification of parental consent, we take steps to remove that information from our servers.

                    <div class="text-h6 mt-5">Changes To This Privacy Policy</div>
                    We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.

                    <br><br>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.

                    <div class="text-h6 mt-5">Contact Us</div>
                    If you have any questions about this Privacy Policy please contact us by email at meetaboutit@gmail.com.
                    

                </div>
            </v-container>
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Home',
    computed:{
        smallScreen() {
            return this.$vuetify.breakpoint.smAndDown ? true : false
        },
        mediumScreen() {
            return this.$vuetify.breakpoint.mdAndDown ? true : false
        }
    },
    data: () => ({
        cards: [{
            title: 'Team Workflows',
            icon: 'fat fa-share-alt',
            body: 'Share Meeting Topics and Agendas'
        }, {
            title: '1:1 or Groups',
            icon: 'fat fa-user-friends',
            body: 'Work closely no matter the group size'
        }, {
            title: 'Reporting',
            icon: 'fat fa-chart-pie',
            body: 'Rich reporting shows what you are discussing and how often'
        }, {
            title: 'Quick Searching',
            icon: 'fat fa-search',
            body: 'Quickly find information from any of your meetings'
        }, {
            title: 'Integrations',
            icon: 'fat fa-share-alt',
            body: 'Integrated with Google Calendar and Slack for quick communication'
        }, {
            title: 'Grows With Your Team',
            icon: 'fat fa-usd-square',
            body: 'Simple pricing makes it easy to get started'
        }]
    })
  }
</script>

<style lang="scss" scoped>
.background {
    position: absolute;
    width: 100%;
    top: 0;
    height: 100%;
    overflow: hidden;
    background-image: url(~@/assets/teamBackground.jpeg);
    background-repeat: no-repeat;
    background-size: cover;
    overflow: scroll;
}

.product-summary {
    margin-top: 200px;
    margin-bottom: 200px;
    background: white;
    padding: 80px 40px 100px 40px;
}
</style>
